class AnimationController {
    constructor() {
        // Track active animations for cleanup
        this.activeAnimations = new Set();
    }

    // Kill all tweens for a given target
    static killTweensOf(target) {
        if (window.gsap) {
            window.gsap.killTweensOf(target);
        }
    }

    // Animate camera position with automatic cleanup
    static animateCamera(camera, target, options = {}) {
        // Kill existing camera animations to prevent conflicts
        this.killTweensOf(camera.position);
        
        const animationOptions = {
            x: target.x,
            y: target.y,
            z: target.z !== undefined ? target.z : camera.position.z,
            duration: options.duration || 0.3,
            ease: options.ease || "power2.out",
            ...options
        };

        return gsap.to(camera.position, animationOptions);
    }

    // Animate camera frustum properties
    static animateCameraFrustum(camera, frustumTarget, options = {}) {
        this.killTweensOf(camera);
        
        const animationOptions = {
            left: frustumTarget.left,
            right: frustumTarget.right,
            top: frustumTarget.top,
            bottom: frustumTarget.bottom,
            duration: options.duration || 0.3,
            ease: options.ease || "power2.out",
            onUpdate: () => camera.updateProjectionMatrix(),
            ...options
        };

        return gsap.to(camera, animationOptions);
    }

    // Animate material color
    static animateMaterialColor(material, targetColor, options = {}) {
        this.killTweensOf(material.color);
        
        const animationOptions = {
            r: targetColor.r,
            g: targetColor.g,
            b: targetColor.b,
            duration: options.duration || 0.2,
            ease: options.ease || "power2.out",
            ...options
        };

        return gsap.to(material.color, animationOptions);
    }

    // Create a timeline for complex animations
    static createTimeline(options = {}) {
        return gsap.timeline(options);
    }

    // Set immediate values without animation
    static set(target, properties) {
        return gsap.set(target, properties);
    }

    // Kill all animations globally
    static killAll() {
        if (window.gsap) {
            window.gsap.killTweensOf("*");
        }
    }

    // Batch multiple animations to start simultaneously
    static batch(animations) {
        return Promise.all(animations.map(anim => anim()));
    }
}

export { AnimationController }; 